export default __webpack_public_path__ + "static/media/BinocularIcon.41511b37.svg";